import { render, staticRenderFns } from "./ModalDocumentStyle.vue?vue&type=template&id=f9823990"
import script from "./ModalDocumentStyle.vue?vue&type=script&lang=js"
export * from "./ModalDocumentStyle.vue?vue&type=script&lang=js"
import style0 from "./ModalDocumentStyle.vue?vue&type=style&index=0&id=f9823990&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports